import Vue from 'vue';
import Router from 'vue-router';
import Page from '../components/pages/page';
import Performers from '../components/pages/performers';
import Profile from '../components/pages/profile';
import Textpages from '../components/pages/textpages';
import store from '../store';

Vue.use(Router);

const router = new Router({
    routes: [{
        path: '/',
        name: 'Home',
        component: Page,
        children: [
            {
                path: ':slug?/',
                name: 'Performers',
                component: Performers
            },
            {
                path: 'categorie/:category?/',
                name: 'PerformersCat',
                component: Performers
            },
            {
                path: 'profile/:id',
                name: 'Profile',
                component: Profile,
                meta: {
                    title: 'profile'
                }
            },
            {
                path: 'pages/:name',
                name: 'Textpages',
                component: Textpages
            }
        ],
    }],
    mode: 'history'
});

export default router;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/router/index.ts